import { createConfirmation } from "react-confirm";
import SelectIngredientDialog from "./SelectIngredientDialog";

export const showSelectIngredientDialog = createConfirmation(SelectIngredientDialog);
